import { render } from "./outdoor-equipment.vue?vue&type=template&id=5789b5b0"
import script from "./outdoor-equipment.vue?vue&type=script&lang=js"
export * from "./outdoor-equipment.vue?vue&type=script&lang=js"

import "./outdoor-equipment.vue?vue&type=style&index=0&id=5789b5b0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__